import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';
import { locationKeyFromName } from '../lib/schedule.js';

// Today's weather card for the web Daily view (CJ 2026-07-29). Reads the same
// forecast endpoint the kiosk/This-Week views use (GET /api/weather/:locationKey
// → { available, today, days }) and shows a compact single-day summary. Quietly
// self-hides if the forecast is unavailable so Daily never shows a broken tile.

const CODE_EMOJI = {
  0: '☀️', 1: '☀️', 2: '⛅', 3: '☁️', 45: '🌫', 48: '🌫',
  51: '🌦', 53: '🌦', 55: '🌦', 56: '🌦', 57: '🌦',
  61: '🌧', 63: '🌧', 65: '🌧', 66: '🌧', 67: '🌧',
  71: '❄️', 73: '❄️', 75: '❄️', 77: '❄️',
  80: '🌧', 81: '🌧', 82: '🌧', 85: '❄️', 86: '❄️',
  95: '⛈', 96: '⛈', 99: '⛈',
};

export function TodayWeather({ user, location }) {
  const headers = { 'x-user-id': String(user.id) };
  const locKey = location ? locationKeyFromName(location.name) : null;
  const [today, setToday] = useState(null);

  useEffect(() => {
    let live = true;
    if (!locKey) { setToday(null); return; }
    (async () => {
      try {
        const r = await api('GET', `/api/weather/${locKey}`, null, headers);
        if (live) setToday(r && r.available ? r.today : null);
      } catch { if (live) setToday(null); }
    })();
    return () => { live = false; };
  }, [locKey]);

  if (!today) return null;
  const emoji = CODE_EMOJI[today.weather_code] || '🌤';

  return (
    <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '12px 16px' }}>
      <span style={{ fontSize: 34, lineHeight: 1 }}>{emoji}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 11, color: '#9e9e9e', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
          Today's weather
        </div>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#212121' }}>
          {today.temp_high}° <span style={{ color: '#9e9e9e', fontWeight: 500 }}>high</span>
          <span style={{ color: '#cfcfcf', margin: '0 6px' }}>·</span>
          {today.temp_low}° <span style={{ color: '#9e9e9e', fontWeight: 500 }}>low</span>
          {today.precipitation_pct > 0 && (
            <span style={{ color: '#1565c0', fontWeight: 600, marginLeft: 10 }}>💧 {today.precipitation_pct}%</span>
          )}
        </div>
      </div>
    </div>
  );
}
